<template>
    <div>
        <h2>{{ $t("menu.facturation.balance_account") }}</h2>
        <div class="box">
            <!-- Le choix de la comptabilité n'a d'intérêt qu'à partir de deux : en mono-compta, elle est déjà sélectionnée -->
            <div class="row" v-if="accounting_plans.length > 1">
                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label for="accountingplan_id">{{ $t('tiers.billing_entity') }} *</label>
                        <e-select
                            v-model="accounting_plan"
                            id="accountingplan_id"
                            track-by="accountingplan_id"
                            label="accountingplan_label"
                            :placeholder="getTrad('tiers.rechercher_billing_entity')"
                            :selectedLabel="getTrad('global.selected_label')"
                            :options="accounting_plans"
                            :searchable="true"
                            :allow-empty="false"
                            :loading="isLoadingAccountingPlan"
                            :show-labels="false"
                            @input="loadBalanceAccounts"
                        >
                            <template slot="singleLabel" slot-scope="{ option }">{{ option.accountingplan_label }}</template>
                            <template slot="noOptions">{{ $t('global.list_empty') }}</template>
                        </e-select>
                    </div>
                </div>
            </div>

            <CustomTable
                v-if="accounting_plan"
                id_table="balance_account"
                ref="balance_account_table"
                :items="accounts"
                :busy.sync="table_busy"
                primaryKey="tiers_id"
                :hide_if_empty="true"
                :externSlotColumns="extern_slot_columns"
            >
                <template v-slot:[`custom-slot-cell(tiers_rs)`]="{ data }">
                    <router-link :to="{ name: 'tiersFiche', params: { tiers_id: data.tiers_id }}">
                        <tiers-moral-icon :moral="data.tiers_moral" />{{ data.tiers_rs }}
                    </router-link>
                </template>
                <template v-slot:[`custom-slot-cell(currentaccount_balance)`]="{ data }">
                    <router-link :to="{ name: 'tiersPayment', params: { tiers_id: data.tiers_id }}">
                        <PriceFormat
                            :pathArr="data"
                            :price="data.currentaccount_balance"
                            currency="currentaccount_currency"
                            :symbol="true"
                        />
                    </router-link>
                </template>
            </CustomTable>
        </div>

        <b-modal ref="modalAbandon" hide-footer @hidden="resetAbandon">
            <template v-slot:modal-title>
                {{ $t("balance_account.abandon_title") }}
            </template>

            <p>{{ $t('balance_account.abandon_message') }}</p>

            <div class="form-group">
                <label for="justification">{{ $t('balance_account.justification') }} *</label>
                <textarea id="justification" class="form-control" v-model="justification" rows="3"></textarea>
            </div>

            <div class="col-8 m-auto">
                <b-button block pill variant="primary" :disabled="!justification || processing" @click="onSubmitAbandon">
                    <font-awesome-icon v-if="processing" :icon="['fas', 'spinner']" pulse /> {{ $t("balance_account.abandon_action") }}
                </b-button>
            </div>
        </b-modal>
    </div>
</template>


<script type="text/javascript">
    import TableAction from "@/mixins/TableAction.js"
    import Navigation from "@/mixins/Navigation.js"
    import Accounting from "@/mixins/Accounting.js"
    import Payment from "@/mixins/Payment.js"

    export default {
        name: "BalanceAccount",
        mixins: [TableAction, Navigation, Accounting, Payment],
        props: [],
        data () {
            return {
                accounting_plan: null,
                accounting_plans: [],
                isLoadingAccountingPlan: false,
                accounts: [],
                table_busy: false,
                processing: false,
                justification: '',
                selected_tiers: [],
                extern_slot_columns: ['tiers_rs', 'currentaccount_balance'],
                events_tab: {
                    'TableAction::goToAbandonCurrentAccount': this.openModalAbandon,
                },
            }
        },
        mounted() {
            this.init_component()
        },
        methods: {
            async init_component() {
                this.isLoadingAccountingPlan = true
                this.accounting_plans = await this.loadAccountingPlans() || []
                this.isLoadingAccountingPlan = false

                // Sélection de la première comptabilité pour lancer la recherche immédiatement
                if(this.accounting_plans.length > 0) {
                    this.accounting_plan = this.accounting_plans[0]
                    await this.loadBalanceAccounts()
                }
            },
            async loadBalanceAccounts() {
                if(!this.accounting_plan) {
                    this.accounts = []
                    return
                }

                // On repart d'une sélection vierge : les tiers soldés disparaissent de la liste
                if(this.$refs.balance_account_table) {
                    this.$refs.balance_account_table.unselectAll()
                }

                this.table_busy = true
                this.accounts = await this.loadBalanceAccountTiers(this.accounting_plan.accountingplan_id)
                this.table_busy = false
            },
            openModalAbandon(tiers_ids) {
                this.selected_tiers = tiers_ids
                this.justification = ''
                this.$refs.modalAbandon.show()
            },
            async onSubmitAbandon() {
                if(this.processing || !this.justification) {
                    return
                }

                this.processing = true
                await this.abandonBalanceAccount(this.selected_tiers, this.accounting_plan.accountingplan_id, this.justification)
                this.$refs.modalAbandon.hide()
                this.processing = false

                await this.loadBalanceAccounts()
            },
            resetAbandon() {
                this.justification = ''
                this.selected_tiers = []
            },
        },
        components: {
            CustomTable: () => import('GroomyRoot/components/Table/CustomTable'),
            PriceFormat: () => import('GroomyRoot/components/Format/PriceFormat'),
        }
    }
</script>
